export enum TrustPilotLocale {
  EN_CA = 'en-CA',
  FR_CA = 'fr-CA'
}
